module.exports = __webpack_public_path__ + "img/truebill.6812b918.jpg";